import type { FunctionComponent } from 'react';

import { Box, Group, Text, Badge } from '@mantine/core';
import ToggleCard from 'primitives/ToggleCard/ToggleCard';

import { transformHours24To12, getDayAbbreviation } from 'helpers/format';
import { BADGE_VARIANTS } from 'constants/mantineVariants';
import { MENU_TYPE_LABELS } from 'constants/menuManagement';
import { sortByCustomDaysOrder } from './helpers/helpers';

export type DisplayHourRange = {
  from: string;
  to: string;
};

export type DisplayHourDay = {
  day_id?: number | null;
  dow: string;
  ranges: DisplayHourRange[];
};

type RenderHoursProps = {
  title: string;
  displayHours: DisplayHourDay[];
  fulfillmentType?: string;
  xMenuId?: string;
  menuType?: string;
};

export const RenderHours: FunctionComponent<RenderHoursProps> = ({
  title,
  displayHours,
  fulfillmentType,
  xMenuId,
  menuType,
}) => {
  const id = fulfillmentType || xMenuId;
  const sortedDisplayHours = sortByCustomDaysOrder(displayHours);
  const menuTypeLabel = menuType && MENU_TYPE_LABELS[menuType.toLowerCase()];

  return (
    <ToggleCard
      title={title}
      badge={
        menuTypeLabel ? (
          <Badge size="xs" variant={BADGE_VARIANTS.outline}>
            {menuTypeLabel}
          </Badge>
        ) : null
      }
    >
      <Box>
        {sortedDisplayHours.map(day => (
          <Group key={`${id}-${day.day_id}`} align="flex-start" mt="xs">
            <Text style={{ minWidth: 80 }}>{getDayAbbreviation(day.dow.toString())}</Text>
            <Box>
              {day.ranges.length > 0 ? (
                day.ranges.map(range => (
                  <Text key={`${id}-${day.day_id}-${range.from}`}>
                    {`${transformHours24To12(range.from, true)} - ${transformHours24To12(range.to, true)}`}
                  </Text>
                ))
              ) : (
                <Text key={`${id}-${day.day_id}-empty`}>—</Text>
              )}
            </Box>
          </Group>
        ))}
      </Box>
    </ToggleCard>
  );
};
